export default __webpack_public_path__ + "static/media/ic_alert_humidity.23fbcaa4.svg";